module.exports = __webpack_public_path__ + "static/media/053-Marr Hotel.a9d2e0a5.jpg";